module.exports = __webpack_public_path__ + "img/vn.12609fbf.svg";